<template>
    <div class="browser-banner-container">
            <div class="conferencing-browser-banner">
                <div class="conferencing-browser-banner__content">
                    <span class="conferencing-browser-banner__content_icon">
                        <img src="@/assets/icons/icons8-error@2x.png" />
                    </span>
                     <span v-html="browserBannerLocalizedBody()"></span>
                </div>
                <div class="conferencing-browser-banner__close" >
                    <a @click="closeBrowserBanner()">
                        <img src="@/assets/images/black_close@2x.png" />
                    </a>
                </div>
            </div>        
        </div>
</template>

<script setup>
import { ref } from 'vue';
import { setBrowserCookie, getBrowserCookie } from '@/utils/helper';
import Constants from "@/utils/constants";
import translate from '@/utils/translate';

// Import composables
import { useConferenceCall, useGlobal } from '@/composables/';

// Define component name
defineOptions({
    name: 'BrowserBanner'
});

// Composables
const { conferenceCallDetails } = useConferenceCall();
const { setHideBrowserBanner } = useGlobal();

// Reactive data
const cookieName = ref('');

// Methods
const browserBannerLocalizedBody = () => {
    const chrome_link = "<a href='https://www.google.com/chrome'>" + translate.L("browser_banner.chrome_link") + "</a>";
    const edge_link = "<a href='https://support.microsoft.com/en-us/help/4501095/download-the-new-microsoft-edge-based-on-chromium'>" + translate.L("browser_banner.edge_link") + "</a>";
    const firefox_link = "<a href='https://www.mozilla.org/en-US/firefox/'>" + translate.L("browser_banner.firefox_link") + "</a>";
    const safari_link = "<a href='https://www.apple.com/safari/'>" + translate.L("browser_banner.safari_link") + "</a>";

    if (conferenceCallDetails.value.ShowType === "Live Video + Slides") {
        return translate.L("browser_banner.bodyLE", { chrome_link: chrome_link, edge_link: edge_link });
    } else {
        return translate.L("browser_banner.body", { chrome_link: chrome_link, firefox_link: firefox_link, safari_link: safari_link, edge_link: edge_link });
    }
};

const initializeBanner = () => {
    var hideBanner = false;
    cookieName.value = Constants.BrowserBannerCookie;
    hideBanner = getBrowserCookie(cookieName.value); //&& (/Trident\/|MSIE/.test(window.navigator.userAgent));
    setHideBrowserBanner(hideBanner);
};

const closeBrowserBanner = () => {
    let hideBanner = false;
    setBrowserCookie(cookieName.value, true, 365);
    hideBanner = getBrowserCookie(cookieName.value); // && (/Trident\/|MSIE/.test(window.navigator.userAgent));
    setHideBrowserBanner(hideBanner);
};

// Initialize immediately (equivalent to created() in Options API)
initializeBanner();
</script>
<style lang="stylus">
.conferencing-browser-banner {
    color: #1f1f1f;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    background: #fff7cc;
    min-height: 35px;
    width: 100%;
    border-bottom: 1px solid #f2e5a9;
    z-index: 1000;
    text-align: center;
    display: table;
    align-items: center;
    justify-content: center;

    &__content {
        display: table-cell;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        flex: 1;
        &_icon{
            vertical-align :sub;
        }
        &_icon img {
            margin-left: 8px;
            margin-right: 5px;
            height: 14px;
        }
        a{
            text-decoration: underline;
        }
    }

    &__close {
        display: table-cell;
        vertical-align :middle;
        cursor: pointer;
        

        img {
            width: 8px;
            height: 8px;
            margin-top: 4px;
            margin-left: 4px;
            border: 1px solid #E0D8A3;;
            border-radius: 3px;
            padding :5px;
        }
    }
}

.browser-banner-container {
    height: 35px;
    width: 100%;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        position: absolute;
        z-index: 999;
    }
}
</style>
